export const CONSENT_CHANGE_EVENT = 'consent-change';

export const CONSENT_MANAGER_ELEMENT_ID = 'transcend-consent-manager';

// Covers an airgap.js that failed to load or threw during init, leaving the ready queue unanswered.
export const AIRGAP_READY_TIMEOUT_MS = 10000;

// User interactions Airgap may accept as proof for setConsent; it refuses untrusted ones.
export const CONSENT_INTERACTION_EVENT_TYPES = [
  'pointerdown',
  'mousedown',
  'touchstart',
  'keydown',
  'wheel',
  'click',
] as const;

// Transcend manages these itself; AlwaysBlock must go too, or a snapshot can never read as accepted-all.
export const NON_CONFIGURABLE_CONSENT_PURPOSES = ['AlwaysBlock', 'Essential', 'Unknown'];

export const CONSENT_RECORDED_PREFERENCE_KEY = 'fooda.consent_sync.recorded_preference';
export const CONSENT_RESTORE_SKIP_REPORTED_KEY = 'fooda.consent_sync.restore_skip_reported';

// Enough of the session token to tell users apart without storing a usable credential.
export const CONSENT_SCOPE_LENGTH = 12;

export const CONSENT_RESTORE_ATTEMPTS = 3;
